import { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemErro, limpaMensagem, setUsuarioCienteMensagens } from "../../providers/actions";
import { ConsentTermAgreement } from "../ConsentTerm/ConsentTermAgreement";
import { PainelCards } from "./PainelCards/PanelCards";


import './Home.css';
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

const mapDispatchToProps = { exibeMensagemErro, limpaMensagem, setUsuarioCienteMensagens }

export const HomeUser =

withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			
			this.irParaInbox = this.irParaInbox.bind(this);
		}

		render() {

			const user = this.props.user;
			const exibeTermoConsentimento = user && user.assinaturaTermoPendente === true;
			const exibePanelCards = user && user.assinaturaTermoPendente === false;
			const exibeModalCienciaMensagens = user && user.isCliente && user.mensagensNaoLidas > 0 && user.usuarioCienteMensagens === false;

			return (
				<Fragment>
					<ConfirmModal titulo="Existem mensagens não lidas" 
						visible={exibeModalCienciaMensagens}
						handleOk={this.irParaInbox}
						handleCancel={() => this.props.setUsuarioCienteMensagens()}
						okText= "Sim"
						cancelText= "Não, tomo ciência em um outro momento"
						width={520}
						>
							<div className="container-body">
							<p>Prezado Gestor.</p>
							<p>Existem mensagens de interesse do seu órgão.</p>
							<p>Deseja tomar ciência delas agora?</p>
						</div>
					</ConfirmModal>

					{exibeTermoConsentimento &&
						<ConsentTermAgreement/>
					}

					{exibePanelCards &&
						<PainelCards/>
					}
				</Fragment>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
		}

		componentWillUnmount() {
			this.props.setUsuarioCienteMensagens();
		}

		irParaInbox() {
			this.props.history.push("/inbox");
		}

	}
) // connect
); // router